/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ComponentType } from 'react';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import { BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES } from '@jira/software__board-settings-rapidboard-config-common/src/boardSettingsQueryConfigParamValues.constants.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '../../constants.tsx';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useHasBoardSettingsPageQueryParam: (args_0: void) => boolean = createRouterSelector(
	(state) => BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.has(state.query.config),
);

/** "header" component above the page's content
 * It contains:
 * - Heading
 * - Breadcrumb
 * - misc buttons such as share, feedback, etc.
 * - tab navigation (if nav v4)
 */
export const useHorizontalNavComponent = (): ComponentType | null => {
	const route = useCurrentRoute();
	const { data: projectData } = useProjectContext();
	const hasBoardSettingsPageQueryParam = useHasBoardSettingsPageQueryParam();

	if (!route.navigation?.horizontal) {
		return null;
	}

	// Board settings pages should not show the horizontal nav.
	// This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
	// as the board settings pages. This code should be removed once the board settings pages have
	// their own dedicated route names.
	if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam) {
		return null;
	}

	if (route.navigation.horizontal === GENERIC_PROJECT_HORIZONTAL_NAV) {
		switch (projectData?.projectType) {
			case CORE_PROJECT:
				return AsyncHorizontalNavJira;
			case SOFTWARE_PROJECT:
				return AsyncHorizontalNavJira;
			default:
				return null;
		}
	}

	return route.navigation.horizontal;
};
